module.exports = __webpack_public_path__ + "static/farmers_orderdetails-c0f69185684d5b201437d39b2402bdcb.png";